import { render, staticRenderFns } from "./portfolioSingle.vue?vue&type=template&id=efb44c08&"
import script from "./portfolioSingle.vue?vue&type=script&lang=js&"
export * from "./portfolioSingle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports